import React, { useState } from 'react';
import { USER_TITLES } from '../../utils/userRoles';
import './UserForm.css';

const UserForm = ({ onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    UserName: '',
    Email: '',
    Password: '',
    ConfirmPassword: '',
    Name: '',
    Surname: '',
    Title: 'Avukat'
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.UserName.trim()) {
      newErrors.UserName = 'Kullanıcı adı gereklidir';
    }

    if (!formData.Email.trim()) {
      newErrors.Email = 'E-posta gereklidir';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email)) {
      newErrors.Email = 'Geçerli bir e-posta adresi giriniz';
    }

    if (!formData.Password) {
      newErrors.Password = 'Şifre gereklidir';
    } else if (formData.Password.length < 6) {
      newErrors.Password = 'Şifre en az 6 karakter olmalıdır';
    }

    if (formData.Password !== formData.ConfirmPassword) {
      newErrors.ConfirmPassword = 'Şifreler eşleşmiyor';
    }

    if (!formData.Name.trim()) {
      newErrors.Name = 'Ad gereklidir';
    }

    if (!formData.Surname.trim()) {
      newErrors.Surname = 'Soyad gereklidir';
    }

    if (!formData.Title) {
      newErrors.Title = 'Ünvan seçiniz';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const { ConfirmPassword, ...submitData } = formData;
      // Role: create gate (Admin). Gerçek sistem yetkisi backend'de Lawyer kalır.
      // Title/AssignedRole: yalnızca ünvan.
      submitData.Role = 'Admin';
      submitData.AssignedRole = formData.Title;
      onSubmit(submitData);
    }
  };

  return (
    <div className="user-form-overlay">
      <div className="user-form">
        <h2>Yeni Kullanıcı Ekle</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Ad *</label>
              <input
                type="text"
                name="Name"
                value={formData.Name}
                onChange={handleChange}
                className={`form-control ${errors.Name ? 'error' : ''}`}
                required
              />
              {errors.Name && <span className="error-message">{errors.Name}</span>}
            </div>
            <div className="form-group">
              <label>Soyad *</label>
              <input
                type="text"
                name="Surname"
                value={formData.Surname}
                onChange={handleChange}
                className={`form-control ${errors.Surname ? 'error' : ''}`}
                required
              />
              {errors.Surname && <span className="error-message">{errors.Surname}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Kullanıcı Adı *</label>
              <input
                type="text"
                name="UserName"
                value={formData.UserName}
                onChange={handleChange}
                className={`form-control ${errors.UserName ? 'error' : ''}`}
                required
              />
              {errors.UserName && <span className="error-message">{errors.UserName}</span>}
            </div>
            <div className="form-group">
              <label>E-posta *</label>
              <input
                type="email"
                name="Email"
                value={formData.Email}
                onChange={handleChange}
                className={`form-control ${errors.Email ? 'error' : ''}`}
                required
              />
              {errors.Email && <span className="error-message">{errors.Email}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Şifre *</label>
              <input
                type="password"
                name="Password"
                value={formData.Password}
                onChange={handleChange}
                className={`form-control ${errors.Password ? 'error' : ''}`}
                required
              />
              {errors.Password && <span className="error-message">{errors.Password}</span>}
            </div>
            <div className="form-group">
              <label>Şifre Tekrar *</label>
              <input
                type="password"
                name="ConfirmPassword"
                value={formData.ConfirmPassword}
                onChange={handleChange}
                className={`form-control ${errors.ConfirmPassword ? 'error' : ''}`}
                required
              />
              {errors.ConfirmPassword && <span className="error-message">{errors.ConfirmPassword}</span>}
            </div>
          </div>

          <div className="form-group">
            <label>Ünvan *</label>
            <select
              name="Title"
              value={formData.Title}
              onChange={handleChange}
              className={`form-control ${errors.Title ? 'error' : ''}`}
              required
            >
              {USER_TITLES.map((title) => (
                <option key={title.value} value={title.value}>{title.label}</option>
              ))}
            </select>
            <small className="form-text">
              Ünvan yalnızca unvan bilgisidir; Baran ve Beril kullanıcılarının özel izinleri etkilenmez.
            </small>
            {errors.Title && <span className="error-message">{errors.Title}</span>}
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="btn btn-secondary">
              İptal
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Oluşturuluyor...' : 'Kullanıcı Oluştur'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForm;
